import { useMemo } from 'react';
import { AppInitializing } from '@/screens/Initializing';
import { useAppSelector } from '@/store';

export function AppInitializedGuard(props: ChildrenProps) {
  const appState = useAppSelector(state => state.appState);
  const appReady = useMemo(() => appState.initialized && !appState.initializing, [appState.initialized, appState.initializing]);

  if (!appReady) return <AppInitializing />;

  return props.children;
}